import React, { createContext, useEffect, useState } from "react";
import Home from "./components/Home";
import Loading from "./components/Loading";

export const MyContext = createContext();

function App() {
  const [Lang, setLang] = useState('Eng');
  const [looder, setLooder] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve,2000));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLooder(false);
      }
    };
    fetchData();
  }, []);

  return (looder ?
    <Loading />
    :
    <MyContext.Provider value={{ Lang, setLang }}>
      <Home />
    </MyContext.Provider>

  );
}

export default App;
